import { useContext, useState, useEffect } from 'react';
import ListHeader from '../../SectionHeader';
import TablePagination from '../../TablePaginationComponent';
import GlobalContext from '../../../contexts/index';
import useFetchData from '../../../hooks/useFetchData';
import useSort from '../../../hooks/useSort';
import { ReactComponent as SortIcon } from '../../../assets/images/sort.svg';
import Filter from '../../Filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import globalTranslating from '../../../translate.json';
import UserTranslating from '../translate.json';
import SnackBar from 'components/SnackBar';

const UsersList = () => {
  const translating = { ...globalTranslating, ...UserTranslating };
  const navigate = useNavigate();
  const { setLink } = useContext(GlobalContext);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const { data: usersData, loading } = useFetchData('user');
  const [searchParams] = useSearchParams();
  const [showSnackbar, setShowSnakbar] = useState(false);

  useEffect(() => {
    const isAdded = searchParams.get('added');
    if (isAdded) {
      setShowSnakbar(true);
      searchParams.delete('added');
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}${window.location.pathname}`
      );
    }
  }, []);

  useEffect(() => {
    if (usersData?.length) setFilteredUsers(usersData);
  }, [usersData]);

  const onFilter = (filteredData) => {
    setFilteredUsers(filteredData);
  };

  const onResetFilters = () => {
    setFilteredUsers(usersData);
  };

  const { showFilters, toggle } = useSort();

  const tableHeaders = [
    'id',
    translating.firstName,
    translating.lastName,
    translating.userDescription,
    translating.userEmail,
    translating.userMobile,
    translating.userPersmission,
    translating.userCreatedDate,
    translating.userStatus
  ];

  const columns = [
    { value: 'id' },
    { value: 'first_name', bold: true },
    { value: 'last_name' },
    { value: 'job_description' },
    { value: 'email', bold: true },
    { value: 'mobile' },
    { value: 'role', subField: 'name' },
    { value: 'createdAt', format: 'date' },
    { value: 'isActive', sort: true, format: 'status' }
  ];

  const sortFields = [
    {
      type: 'search',
      label: translating.search,
      placeholder: translating.type3Dots,
      name: 'search',
      fields: ['first_name', 'last_name', 'email']
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'createdAt'
    },
    {
      type: 'select',
      label: translating.status,
      name: 'isActive',
      options: [
        { id: true, name: 'פעיל' },
        { id: false, name: 'חסום' }
      ]
    }
  ];

  const actionsUsersList = [
    {
      icon: SortIcon,
      bottom: true,
      txt: translating.edit,
      handleClickAction: () => {
        showFilters && setFilteredUsers(usersData);
        toggle(!showFilters);
      }
    }
  ];

  return (
    <div className="users-list">
      <ListHeader
        title={translating.usersListTitle}
        newItem={{ handleClick: () => setLink('d2') }}
        actions={actionsUsersList}
      ></ListHeader>
      {showFilters && (
        <Filter
          fields={sortFields}
          data={usersData}
          handleFilter={onFilter}
          handleReset={onResetFilters}
        ></Filter>
      )}
      <div className="users-list-wrapper-table">
        {loading && <div>Loading</div>}
        {usersData && (
          <TablePagination
            headers={tableHeaders}
            columns={columns}
            rows={filteredUsers}
            pagination={true}
            handleRowClick={(id, e, row) => {
              navigate(`/users/${row.user_uuid}`);
            }}
          ></TablePagination>
        )}
      </div>
      {showSnackbar && (
        <SnackBar
          msg={'משתמש נוסף'}
          handleClose={() => setShowSnakbar(false)}
        ></SnackBar>
      )}
    </div>
  );
};

export default UsersList;
